// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

// assets
import PathologyIcon from "../assets/icons/diseases.svg";

const icons = {
  pathologies: () => <img src={PathologyIcon} alt="pathology icon" />,
};

// ==============================|| MENU ITEMS - PATHOLOGIES PAGE ||============================== //

const pathologies = {
  id: "pathologies",
  title: <FormattedMessage id="pathologies" />,
  type: "group",
  url: "/pathologies",
  icon: icons.pathologies,
};

export default pathologies;